module.exports = __webpack_public_path__ + "static/media/wa-background-dark.8244f042.png";